import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, CaretLeft } from "@phosphor-icons/react";
import { getService, getDoctors } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    getService(slug).then(setService).catch(() => {});
    getDoctors(slug).then(setDoctors).catch(() => {});
  }, [slug]);

  if (!service) return <div className="max-w-3xl mx-auto p-16 text-brand-muted">Loading…</div>;

  return (
    <div data-testid="service-detail-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-10">
        <Link to="/services" className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-ink" data-testid="back-to-services">
          <CaretLeft size={16} /> Back to services
        </Link>
      </div>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-8 pb-20 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.28em] text-brand-sage mb-5">{service.short_description}</div>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[1.02]">{service.name}</h1>
          <p className="mt-7 text-lg text-brand-muted leading-relaxed">{service.description}</p>
          <div className="mt-8 flex gap-4">
            <Link to="/book">
              <Button data-testid="service-book-btn" className="rounded-full bg-[#C85A40] hover:bg-[#A94A32] text-white h-13 px-7">
                Book with a {service.name} specialist <ArrowRight size={18} className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden border border-brand-border" style={{ backgroundColor: service.accent }}>
            <img src={service.image} alt={service.name} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {doctors.length > 0 && (
        <section className="bg-[#F0EEE6] py-20 border-t border-brand-border">
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight mb-10">Doctors in this department</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {doctors.map((d) => (
                <Link key={d.id} to={`/doctors/${d.id}`} className="group bg-white rounded-3xl overflow-hidden border border-brand-border hover:-translate-y-1 transition-transform" data-testid={`dept-doctor-${d.id}`}>
                  <div className="aspect-[4/5]"><img src={d.image} alt={d.name} className="w-full h-full object-cover" /></div>
                  <div className="p-5">
                    <div className="text-xs uppercase tracking-wider text-brand-sage mb-1">{d.specialty}</div>
                    <div className="font-serif text-xl text-brand-ink">{d.name}</div>
                    <div className="text-sm text-brand-muted mt-1.5">{d.experience_years} yrs · {d.languages.join(", ")}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
